function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 30,
    height: 20,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 5,
    width: 15,
    height: 10,
    style: {
      fill: "#da121a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.121 19.41 22.5 17.5 21.881 19.41 19.87 19.41 21.498 20.592 20.88 22.5 22.501 21.321 24.125 22.5 23.504 20.591 25.127 19.41 23.121 19.41",
    style: {
      fill: "#da121a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 15,
    height: 10,
    style: {
      fill: "#072357"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.496 10.591 5.875 12.5 7.5 11.32 9.125 12.5 8.504 10.591 10.13 9.41 8.121 9.41 7.5 7.5 6.879 9.41 4.87 9.41 6.496 10.591",
    style: {
      fill: "#072357"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 35.981,
    y: 18.454,
    width: 29.999,
    height: 20,
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPa);
export default __webpack_public_path__ + "static/media/PA.3d6506530b4c33cb2167cd6995505286.svg";
export { ForwardRef as ReactComponent };